import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { FloatingFocusManager, FloatingList } from '@floating-ui/react';
import classnames from 'classnames';
import { AnimatePresence, motion } from 'framer-motion';
import { useStackedHandleOnEscape } from '../../../EscapeHandlerStack/hooks/use-stacked-handle-on-escape.js';
import { useDropdownContext } from '../../context/ButtonDropdownContext.js';

const styleVariants = {
    enter: {
        opacity: 1,
        y: 0,
        overflow: 'hidden',
        transitionEnd: {
            overflow: ''
        }
    },
    exit: {
        opacity: 0,
        y: -25,
        overflow: 'hidden',
        transition: {
            duration: 0
        }
    }
};
const ButtonDropdownContent = ({ children , className , restoreFocus , type ='generic' ,  })=>{
    const { 'aria-label': ariaLabel , close , cols , contentId , floatingProps: { itemsRef , getFloatingProps , floatingContext  } , isOpen ,  } = useDropdownContext();
    useStackedHandleOnEscape({
        isOpen,
        handler: close
    });
    const contentClassnames = classnames('button-dropdown-content__floating-container', className, {
        'button-dropdown-content__floating-container--is-open': isOpen
    });
    const handleKeyDown = (event)=>{
        const firstOption = itemsRef.current[0];
        // in order to be compatible with current keyboard navigation
        // when using native select, when tab is pressed, we focus the first
        // option of the list while focus is trapped inside this content div
        if (event.key === 'Tab' && firstOption) {
            firstOption.focus();
        }
    };
    const selectRole = cols && cols > 1 ? 'grid' : 'listbox';
    const ariaRole = type === 'select' ? selectRole : 'dialog';
    var _y, _x;
    return /*#__PURE__*/ React.createElement("div", {
        className: "button-dropdown-content",
        role: "presentation",
        tabIndex: -1
    }, /*#__PURE__*/ React.createElement(AnimatePresence, null, isOpen && /*#__PURE__*/ React.createElement(FloatingFocusManager, {
        context: floatingContext,
        restoreFocus: restoreFocus
    }, /*#__PURE__*/ React.createElement(motion.div, swcHelpers.extends({
        initial: "exit",
        animate: "enter",
        exit: "exit",
        variants: styleVariants,
        className: contentClassnames,
        ref: floatingContext.refs.setFloating,
        "data-t": "button-dropdown-content",
        role: ariaRole,
        "aria-label": ariaLabel,
        id: contentId,
        style: {
            position: floatingContext.strategy,
            top: (_y = floatingContext.y) !== null && _y !== void 0 ? _y : 0,
            left: (_x = floatingContext.x) !== null && _x !== void 0 ? _x : 0
        }
    }, getFloatingProps({
        onKeyDown: handleKeyDown
    })), /*#__PURE__*/ React.createElement(FloatingList, {
        elementsRef: itemsRef
    }, children)))));
};

export { ButtonDropdownContent };
//# sourceMappingURL=ButtonDropdownContent.js.map
